export class ImportAndExportDataFilter {

  constructor() { }

  search: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/user/model/importAndExportDataFilter.ts